import React, { FC, useCallback } from 'react';

import {
  CloseCircleFilled,
  CheckCircleFilled,
  RefreshCircleFilled,
  DocumentDownloadOutline,
  DeleteOutline,
} from 'ui/components/Icon';
import Button from 'ui/components/Buttons';

import { UploadItemProps } from './types';
import { ButtonGroup } from './styled';

export interface UploadButtonGroupProps extends Pick<UploadItemProps, 'file'> {
  isUploaded: boolean;
  canDeleteUploaded?: boolean;
  onRemove: () => void;
  onDownload: () => void;
  showRefreshButton?: boolean;
}

const UploadButtonGroup: FC<UploadButtonGroupProps> = ({
  file,
  isUploaded,
  canDeleteUploaded = false,
  onRemove,
  onDownload,
  showRefreshButton,
}) => {
  const handleClick = useCallback(() => {
    if (file.status !== 'done') onRemove();
  }, [file.status, onRemove]);

  return (
    <ButtonGroup>
      {file.status === 'error' && showRefreshButton && (
        <Button type='link' size='small' onClick={handleClick}>
          <RefreshCircleFilled />
        </Button>
      )}

      {isUploaded && (
        <Button type='link' size='small' onClick={onDownload}>
          <DocumentDownloadOutline />
        </Button>
      )}

      {!isUploaded && (
        <>
          {file.percent === 100 && file.status && <CheckCircleFilled />}
          <Button type='link' size='small' onClick={handleClick}>
            <CloseCircleFilled />
          </Button>
        </>
      )}

      {isUploaded && canDeleteUploaded && (
        <Button type='link' size='small' onClick={onRemove}>
          <DeleteOutline />
        </Button>
      )}
    </ButtonGroup>
  );
};

export default UploadButtonGroup;
